export const LOCALE_ALIASES: Record<string, string> = {
  "en-AU": "en-US",
  "en-CA": "en-US",
  "en-IN": "en-US",
  "en-SG": "en-US",
  "en-ZA": "en-US",
  "fa-AE": "fa",
  "fa-IR": "fa",
};
